var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('progress',{ref:"progress",staticClass:"t-progress",class:[
    ("t-progress--" + _vm.type) ],attrs:{"max":_vm.max},domProps:{"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }